import React, { Component } from 'react';

import logodif from './componentes/Image/Logo_SNDIF.png'

export class AppProfile extends Component {

    constructor() {
        super();
        this.state = {
            expanded: false
        };
        
    }


    render() {
        return  (
            <div className="layout-profile">
                <div>
                    <img src={logodif} alt="" style={{ height: '81px', width: '191px' }}/>
                </div>
                <button className="p-link layout-profile-link">
                    <span className="username"></span>
                </button>
            </div>
        );
    }
}